import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import BlockSlide from './BlockSlide';
import DotsStepper from 'components/pages/Solution/Marketing/SliderBlock/DotsStepper';

const ContentBloc = styled(Grid)`
  text-align: center;
  position: relative;
  width: 100%;
  ${breakpoint.down('md')`
  padding: 2rem 0 1rem 0 !important;`}
`;
const BottomDots = styled(Grid)`
  padding-top: 4rem;
  ${breakpoint.down('md')`
  padding-top: 0`}
  ${breakpoint.down('sm')`
  padding: 0 4rem;`}
`;
class SliderTeam extends React.Component {
  state = {
    activeStep: 0,
    images: 0,
  };

  handleStepChange = activeStep => {
    this.setState({ activeStep });
  };

  render() {
    const { images } = this.props;
    const { activeStep } = this.state;
    return (
      <ContentBloc
        container
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        direction="row"
        justify="center"
        id="teamBlock"
      >
        {images && (
          <>
            <BlockSlide
              images={images}
              activeStep={activeStep}
              handleStepChange={this.handleStepChange}
            />
          </>
        )}
        <BottomDots container item justify="center" xs={10} sm={8}>
          <DotsStepper
            maxSteps={images}
            activeStep={activeStep}
            handleStepChange={index => this.handleStepChange(index)}
          />
        </BottomDots>
      </ContentBloc>
    );
  }
}
export default SliderTeam;
